<template>
  <v-dialog v-model="open" persistent max-width="600">
    <v-card>
      <v-card-title class="headline">{{ $store.state.showMessage.title }}</v-card-title>
      <v-card-text>
        <p class="subtitle-1">{{ $store.state.showMessage.message }}</p>
        <pre class="errorMessage">{{ $store.state.showMessage.subMessage }}</pre>
        <p></p>
      </v-card-text>

      <v-card-actions class="pa-6">
        <v-spacer></v-spacer>
        <!-- <v-btn color="red lighten-2" fab>
          <v-icon color="white" size="32">error</v-icon>
        </v-btn>-->

        <v-btn
          v-if="$store.state.showMessage.buttons.cancel && $store.state.showMessage.buttons.cancel.visible"
          color="secondary lighten-2"
          class="px-4 mr-2"
          depressed
          @click="cancelClick"
        >{{ $store.state.showMessage.buttons.cancel && $store.state.showMessage.buttons.cancel.label }}</v-btn>
        <v-btn
          v-if="$store.state.showMessage.buttons.ok && $store.state.showMessage.buttons.ok.visible"
          color="primary lighten-1"
          class="px-4"
          depressed
          @click="okClick"
        >{{ $store.state.showMessage.buttons.ok && $store.state.showMessage.buttons.ok.label }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    open: Boolean,
    message: String,
    buttons: Array
  },
  data() {
    return {
      agree: false
    };
  },
  methods: {
    cancelClick() {
      if (
        this.$store.state.showMessage.buttons.cancel &&
        this.$store.state.showMessage.buttons.cancel.onClick
      ) {
        this.$store.state.showMessage.buttons.cancel.onClick();
      }
    },
    okClick() {
      if (
        this.$store.state.showMessage.buttons.ok &&
        this.$store.state.showMessage.buttons.ok.onClick
      ) {
        this.$store.state.showMessage.buttons.ok.onClick();
      }
    }
  }
};
</script>
<style scoped>
.errorMessage {
  font-family: inherit;
  font-size: 14px;
  color: red;
  overflow: hidden;
  white-space: break-spaces;
}
</style>